import axios from 'axios';
import $ from 'jquery';
import messages from '../statics/messages.json';
import { Navigate, useNavigate } from 'react-router-dom';

const api = {
    giga_server_host: 'http://localhost:8089'
};
const OrderContext = () => {
    // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
    // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
    const navigate = useNavigate();
    const orderFetch = async (index, maxRecords, searchTerm,sortColumn,sortDirection,dayDiff,startDate,endDate,orderValue,POValue,PartNameSearch,statusValue,ShippingMethodValue,CustomerValue,CountryValue,viewBy,exports,lineId,orderNum,newOrders = false) => {
        
        
    try {
        const response = await axios.get(`${contextPath}/orderService/featchOrderData`, {
            params: {
                index: index,
                maxRecords: maxRecords,
                searchTerm: searchTerm,
                sortColumn:sortColumn,
                sortDirection:sortDirection,
                dayDiff:dayDiff,
                startDate,
                endDate,
                orderSearch:orderValue,
                poSearch:POValue,
                PartName:PartNameSearch,
                statusSearch:statusValue,
                ShippingMethodSearch:ShippingMethodValue,
                customerSearch:CustomerValue,
                countrySearch:CountryValue,
                viewBy,
                exports,lineId,orderNum,newOrders


            },
            withCredentials: true,
        });

        // Check the response status
        if (response.status !== 200) throw new Error(`Can't open with status ${response.status}`);
        
        return response.data;

    } catch (err) {
        debugger
        if(err.status === 401){
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error("Fetch error:", err);
        return null;
        //throw err;
    }
};

    const fetchOrderValidationData = async (index, maxRecords, searchTerm, sortColumn, sortDirection, dayDiff, startDate, endDate, orderValue, POValue, PartNameSearch, statusValue, ShippingMethodValue, CustomerValue, CountryValue, viewBy, exports, lineId, orderNum, newOrders = false) => {
        try {
            const response = await axios.get(`${contextPath}/orderService/fetchOrderValidationData`, {
                params: {
                    index: index,
                    maxRecords: maxRecords,
                    searchTerm: searchTerm,
                    sortColumn: sortColumn,
                    sortDirection: sortDirection,
                    dayDiff: dayDiff,
                    startDate,
                    endDate,
                    orderSearch: orderValue,
                    poSearch: POValue,
                    PartName: PartNameSearch,
                    statusSearch: statusValue,
                    ShippingMethodSearch: ShippingMethodValue,
                    customerSearch: CustomerValue,
                    countrySearch: CountryValue,
                    viewBy,
                    exports,
                    lineId,
                    orderNum,
                    newOrders
                },
                withCredentials: true,
            });

            if (response.status !== 200) throw new Error(`Can't open with status ${response.status}`);

            return response.data;
        } catch (err) {
            if (err.status === 401) {
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error('Fetch order validation data error:', err);
            return null;
        }
    };


    const fetchOrderDetails = async (orderId) => {
        try {
            debugger
            const response = await axios.get(`${contextPath}/orderService/order?orderId=${orderId}`,{withCredentials: true,});
            if (response.status !== 200) throw new Error(`Can't open with status ${response.status}`);
            return response.data;
        } catch (err) {
            console.error(`Error fetching details for order ID ${orderId}:`, err);
                if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
            return null;
        }
    };

    const getNewOrders = async (index, maxRecords, searchTerm, sortColumn, sortDirection, dayDiff, startDate, endDate, orderValue, POValue, PartNameSearch, statusValue, ShippingMethodValue, CustomerValue, CountryValue, viewBy, exports, lineId, orderNum) => {
        try {
            const response = await axios.get(`${contextPath}/orderService/getNewOrders`, {
                params: {
                    index: index,
                    maxRecords: maxRecords,
                    searchTerm: searchTerm,
                    sortColumn: sortColumn,
                    sortDirection: sortDirection,
                    dayDiff: dayDiff,
                    startDate,
                    endDate,
                    orderSearch: orderValue,
                    poSearch: POValue,
                    PartName: PartNameSearch,
                    statusSearch: statusValue,
                    ShippingMethodSearch: ShippingMethodValue,
                    customerSearch: CustomerValue,
                    countrySearch: CountryValue,
                    viewBy,
                    exports,
                    lineId,
                    orderNum
                },
                withCredentials: true,
            });

            // Check the response status
            if (response.status !== 200) throw new Error(`Can't open with status ${response.status}`);
            
            return response.data;

        } catch (err) {
            if (err.status === 401) {
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
            return null;
        }
    };

    const fetchAllNotAcceptedOrders = async (index, maxRecords, searchTerm, sortColumn, sortDirection, dayDiff, startDate, endDate, orderValue, POValue, PartNameSearch, statusValue, ShippingMethodValue, CustomerValue, CountryValue, viewBy, exports, lineId, orderNum) => {
        try {
            const response = await axios.get(`${contextPath}/orderService/fetchAllNotAcceptedOrders`, {
                params: {
                    index: index,
                    maxRecords: maxRecords,
                    searchTerm: searchTerm,
                    sortColumn: sortColumn,
                    sortDirection: sortDirection,
                    dayDiff: dayDiff,
                    startDate,
                    endDate,
                    orderSearch: orderValue,
                    poSearch: POValue,
                    PartName: PartNameSearch,
                    statusSearch: statusValue,
                    ShippingMethodSearch: ShippingMethodValue,
                    customerSearch: CustomerValue,
                    countrySearch: CountryValue,
                    viewBy,
                    exports,
                    lineId,
                    orderNum
                },
                withCredentials: true,
            });

            if (response.status !== 200) throw new Error(`Can't open with status ${response.status}`);
            
            return response.data;

        } catch (err) {
            if (err.status === 401) {
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
            return null;
        }
    };

    const updateOrderReview = async (orderNum, reviewed) => {
        try {
            const isLocal = window.location.hostname === "localhost";
            const port = isLocal ? messages.node_server_port : "";
            const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
            
            const response = await axios.patch(
                `${contextPath}/orderService/updateOrderReview`,
                {
                    orderNum: orderNum,
                    reviewed: reviewed
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );
            
            if (response.status === 200 && response.data.success) {
                return { success: true, message: response.data.message, data: response.data.data };
            }
            return { success: false, message: response.data.message || 'Failed to update review status' };
        } catch (err) {
            console.error('Error updating review status:', err);
            return { success: false, message: err.response?.data?.message || 'Error updating review status' };
        }
    };

    const updateOrderAccept = async (orderNum, accepted) => {
        try {
            const isLocal = window.location.hostname === "localhost";
            const port = isLocal ? messages.node_server_port : "";
            const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
            
            const response = await axios.patch(
                `${contextPath}/orderService/updateOrderAccept`,
                {
                    orderNum: orderNum,
                    accepted: accepted,
                    // Names the user on the order history entry and on the Kitting
                    // notification raised when an assembly order moves to Orders.
                    changedBy: localStorage.getItem('userName') || localStorage.getItem('userEmail') || undefined
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );
            
            if (response.status === 200 && response.data.success) {
                return { success: true, message: response.data.message, data: response.data.data };
            }
            return { success: false, message: response.data.message || 'Failed to update accept status' };
        } catch (err) {
            console.error('Error updating accept status:', err);
            return { success: false, message: err.response?.data?.message || 'Error updating accept status' };
        }
    };

    const updateOrderReady = async (orderNum, ready) => {
        try {
            const isLocal = window.location.hostname === "localhost";
            const port = isLocal ? messages.node_server_port : "";
            const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;

            const response = await axios.patch(
                `${contextPath}/orderService/updateOrderReady`,
                {
                    orderNum: orderNum,
                    ready: ready
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );

            if (response.status === 200 && response.data.success) {
                return { success: true, message: response.data.message, data: response.data.data };
            }
            return { success: false, message: response.data.message || 'Failed to update ready status' };
        } catch (err) {
            console.error('Error updating ready status:', err);
            return { success: false, message: err.response?.data?.message || 'Error updating ready status' };
        }
    };

     const updateArchiveOrder = async (orderNum, archived) => {
        try {
            const isLocal = window.location.hostname === "localhost";
            const port = isLocal ? messages.node_server_port : "";
            const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
            
            const response = await axios.patch(
                `${contextPath}/orderService/updateArchiveOrder`,
                {
                    orderNum: orderNum,
                    archived: archived
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );
            
            if (response.status === 200 && response.data.success) {
                return { success: true, message: response.data.message, data: response.data.data };
            }
            return { success: false, message: response.data.message || 'Failed to update archive status' };
        } catch (err) {
            console.error('Error updating archive status:', err);
            return { success: false, message: err.response?.data?.message || 'Error updating archive status' };
        }
    };

    const updateArchiveOrderLineItem = async (orderLineItemId, archived) => {
        try {
            const isLocal = window.location.hostname === "localhost";
            const port = isLocal ? messages.node_server_port : "";
            const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;

            const response = await axios.patch(
                `${contextPath}/orderService/updateArchiveOrderLineItem`,
                {
                    orderLineItemId: orderLineItemId,
                    archived: archived
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );

            if (response.status === 200 && response.data.success) {
                return { success: true, message: response.data.message, data: response.data.data };
            }
            return { success: false, message: response.data.message || 'Failed to update line archive status' };
        } catch (err) {
            console.error('Error updating line archive status:', err);
            return { success: false, message: err.response?.data?.message || 'Error updating line archive status' };
        }
    };


    const updateArchiveBomPart = async (bomPartId, archived) => {
        try {
            const isLocal = window.location.hostname === "localhost";
            const port = isLocal ? messages.node_server_port : "";
            const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;

            const response = await axios.patch(
                `${contextPath}/orderService/updateArchiveBomPart`,
                {
                    bomPartId: bomPartId,
                    archived: archived
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );

            if (response.status === 200 && response.data.success) {
                return { success: true, message: response.data.message, data: response.data.data };
            }
            return { success: false, message: response.data.message || 'Failed to update BOM part archive status' };
        } catch (err) {
            console.error('Error updating BOM part archive status:', err);
            return { success: false, message: err.response?.data?.message || 'Error updating BOM part archive status' };
        }
    };


    const fetchArchivedOrders = async (index, maxRecords, searchTerm, sortColumn, sortDirection, startDate, endDate, orderSearch, poSearch, PartName, statusSearch, ShippingMethodSearch, customerSearch, countrySearch) => {
        try {
            const params = { index, maxRecords };
            if (searchTerm) params.searchTerm = searchTerm;
            if (sortColumn) { params.sortColumn = sortColumn; params.sortDirection = sortDirection; }
            if (startDate) params.startDate = startDate;
            if (endDate) params.endDate = endDate;
            if (orderSearch) params.orderSearch = orderSearch;
            if (poSearch) params.poSearch = poSearch;
            if (PartName) params.PartName = PartName;
            if (statusSearch) params.statusSearch = statusSearch;
            if (ShippingMethodSearch) params.ShippingMethodSearch = ShippingMethodSearch;
            if (customerSearch) params.customerSearch = customerSearch;
            if (countrySearch) params.countrySearch = countrySearch;

            const response = await axios.get(`${contextPath}/orderService/getArchivedOrders`, {
                params,
                withCredentials: true,
            });
            if (response.status !== 200) throw new Error(`Unexpected status ${response.status}`);
            return response.data;
        } catch (err) {
            if (err.response?.status === 401) {
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error('fetchArchivedOrders error:', err);
            return null;
        }
    };

    const fetchArchivedBomParts = async (index, maxRecords, searchTerm, sortColumn, sortDirection, prcpart, topPart, orderNum) => {
        try {
            const params = { index, maxRecords };
            if (searchTerm) params.searchTerm = searchTerm;
            if (sortColumn) { params.sortColumn = sortColumn; params.sortDirection = sortDirection; }
            if (prcpart) params.prcpart = prcpart;
            if (topPart) params.topPart = topPart;
            if (orderNum) params.orderNum = orderNum;

            const response = await axios.get(`${contextPath}/orderService/getArchivedBomParts`, {
                params,
                withCredentials: true,
            });
            if (response.status !== 200) throw new Error(`Unexpected status ${response.status}`);
            return response.data;
        } catch (err) {
            if (err.response?.status === 401) {
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error('fetchArchivedBomParts error:', err);
            return null;
        }
    };

    return { orderFetch, fetchOrderValidationData, fetchOrderDetails, getNewOrders, fetchAllNotAcceptedOrders, updateOrderReview, updateOrderAccept, updateOrderReady, updateArchiveOrder, updateArchiveOrderLineItem, updateArchiveBomPart, fetchArchivedOrders, fetchArchivedBomParts };
};

export default OrderContext;


// import axios from 'axios';

// const OrderContext = () => {
//     const fetchOrders = async (page, itemsPerPage, searchTerm, index) => {
//         try {
//             const response = await axios.get("http://localhost:5000/orderService/fetchOrderData", {
//                 params: {
//                     page,
//                     maxRecords: itemsPerPage,
//                     searchTerm,
//                     index  // Include the index here
//                 }
//             });
//             return response.data;
//         } catch (err) {
//             console.error("Fetch error:", err);
//             throw err;
//         }
//     };
    
// };

//export default OrderContext;

